import React, { useState, useEffect, useContext, useRef } from "react";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import AuthContext from "../../context/AuthContext";
import Axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import logo from "./logo.png";

function PrintQuotation({ quotation_id }) {
  const { user } = useContext(AuthContext);
  const printRef = useRef();
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [items, setItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [clientFullName, setClientFullName] = useState("");
  const [villageName, setVillageName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  // Get the current date
  const currentDate = formatDateTime(new Date());

  const numberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (num === 0) return "Zero";
    if (num < 20) return a[num];
    if (num < 100)
      return b[Math.floor(num / 10)] + (num % 10 ? " " + a[num % 10] : "");
    if (num < 1000)
      return (
        a[Math.floor(num / 100)] +
        " Hundred" +
        (num % 100 ? " " + numberToWords(num % 100) : "")
      );
    return "Number too large to convert";
  };

  useEffect(() => {
    const fetchQuotationDetails = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/quotation/details/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              quotation_id: quotation_id,
            },
          }
        );

        if (response.status === 200) {
          setItems(response.data);
        }
      } catch (error) {
        console.error("Error fetching quotation details:", error);
      }
    };

    const fetchQuotation = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/quotation/individual/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              quotation_id: quotation_id,
            },
          }
        );

        if (response.status === 200) {
          const data = response.data[0];
          setTotalAmount(data.total_amount || 0);
          setDiscount(data.discount || 0);
          setClientFullName(data.fullname_en || "");
          setVillageName(data.village_name || "");

          // Add leading 0 to phone number if it's 7 digits long
          const phone = data.phone_number || "";
          setPhoneNumber(phone.length === 7 ? `0${phone}` : phone);
        }
      } catch (error) {
        console.error("Error fetching quotation information:", error);
      }
    };

    fetchQuotationDetails();
    fetchQuotation();
  }, [quotation_id, authTokens.access, user.username]);

  // Function to print the quotation
  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      console.error("Print content is not defined");
      return;
    }
    const printWindow = window.open("", "", "height=500, width=800");
    printWindow.document.write(`
      <html>
        <head>
          <title>Quotation</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; color: #333; }
            .header { display: flex; justify-content: space-between; align-items: center; }
            .header .date { font-weight: bold; }
            .client-info { margin-top: 20px; }
            .table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            .table th, .table td { padding: 10px; border: 1px solid #ddd; }
            .table th { background-color:rgb(1, 167, 145);color: white; }
          </style>
        </head>
        <body>
          <div class="header">
            <div style="display:flex,flex-direction:column">
              <img src="${logo}" alt="Logo" style="height: 300px;">
              <p> Ain w zain cross road, main street</p>
              <p>Bakaata, El Chouf, Lebanon</p>
              <p>Phone: 00961- 76842442</p>
            </div>
            <div class="date">Date: ${currentDate}</div>
          </div>
          <h2 style="text-align: center;color:rgb(1, 167, 145);">Quotation</h2>
          <div class="client-info">
            <h4 style="background-color:rgb(1, 167, 145);color: white;">Bill TO:</h4>
            <p><strong>Client:</strong> ${clientFullName}</p>
            <p><strong>Location:</strong> ${villageName}</p>
            <p><strong>Phone:</strong>${phoneNumber}</p>
            <p><strong>Quotation ID:</strong> ${quotation_id}</p>
          </div>
          <div>${printContent.innerHTML}</div>
          <div style="text-align: center; margin-top: 40px;">
            <p>Thank you for your business! We look forward to serving you again.</p>
          </div>
        </body>
      </html>
    `);

    printWindow.onload = function () {
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <div className="quotation-print">
      <h3>Quotation Details</h3>
      <div ref={printRef}>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Quantity</th>
              <th>Selling Price</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.item_type === "Product"
                    ? item.product_name
                    : item.service_name}
                </td>
                <td>{item.quantity}</td>
                <td>
                  {item.item_type === "Product"
                    ? item.product_selling
                    : item.service_selling}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="2" className="text-end">
                Total Amount
              </td>
              <td>{totalAmount}</td>
            </tr>
            <tr>
              <td colSpan="2" className="text-end">
                Discount
              </td>
              <td>{discount}</td>
            </tr>
            <tr>
              <td colSpan="2" className="text-end">
                Total After Discount
              </td>
              <td>{totalAmount - discount}</td>
            </tr>
          </tfoot>
        </table>
        <p style={{ display: "flex", justifyContent: "end" }}>
          {numberToWords(totalAmount - discount)} Dollars
        </p>
      </div>
      <button onClick={handlePrint} className="btn btn-primary mt-3">
        Print Quotation
      </button>
    </div>
  );
}

export default PrintQuotation;
